import { getLocalizedText } from './i18n';

function simpleHash(input: string): string {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = ((hash << 5) - hash + input.charCodeAt(i)) | 0;
  }
  return Math.abs(hash).toString(36);
}

export function hasWelcomeMessageContent(message: unknown): boolean {
  const html = getLocalizedText(message).trim();
  if (!html) return false;
  const textOnly = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return textOnly.length > 0;
}

function getDismissStorageKey(
  courseId: string,
  groupId: string | null | undefined,
  message: unknown
): string {
  const fingerprint = simpleHash(JSON.stringify(message ?? {}));
  return `fc_welcome_dismissed_${courseId}_${groupId || 'none'}_${fingerprint}`;
}

export function isWelcomeMessageDismissed(
  courseId: string,
  groupId: string | null | undefined,
  message: unknown
): boolean {
  if (!hasWelcomeMessageContent(message)) return true;
  try {
    return localStorage.getItem(getDismissStorageKey(courseId, groupId, message)) === '1';
  } catch {
    return false;
  }
}

export function dismissWelcomeMessage(
  courseId: string,
  groupId: string | null | undefined,
  message: unknown
): void {
  try {
    localStorage.setItem(getDismissStorageKey(courseId, groupId, message), '1');
  } catch {
    /* ignore quota / private mode */
  }
}
